const STORAGE_KEY = 'adnuntius.network'
const USER_NETWORK_STORAGE_KEY = 'adnuntius.network.byUser'

/** The current network, which every request is scoped to. */
export function getContext(): string {
  return localStorage.getItem(STORAGE_KEY) || ''
}

/**
 * The last primary network each user worked in on this browser, keyed by user
 * id. `adnuntius.network` is shared by whoever signs in next, so a different
 * account (or a masquerade) overwrites it; this map is what brings a user back
 * to their own last network when they sign in again.
 */
function readUserNetworks(): Record<string, string> {
  try {
    const parsed = JSON.parse(localStorage.getItem(USER_NETWORK_STORAGE_KEY) ?? 'null')
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {}
  } catch {
    return {}
  }
}

export function getUserNetwork(userId: string): string | null {
  const tagId = readUserNetworks()[userId]
  return typeof tagId === 'string' && tagId ? tagId : null
}

export function setUserNetwork(userId: string, tagId: string) {
  try {
    const map = readUserNetworks()
    if (map[userId] === tagId) return
    localStorage.setItem(USER_NETWORK_STORAGE_KEY, JSON.stringify({ ...map, [userId]: tagId }))
  } catch {
    // ignore — the shared key still remembers the network for this browser
  }
}
